var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 9C1.16421 9 1.5 9.33579 1.5 9.75V15.375C1.5 15.9963 2.00368 16.5 2.625 16.5H15.375C15.9963 16.5 16.5 15.9963 16.5 15.375V9.75C16.5 9.33579 16.8358 9 17.25 9C17.6642 9 18 9.33579 18 9.75V15.375C18 16.8247 16.8247 18 15.375 18H2.625C1.17525 18 0 16.8247 0 15.375V9.75C0 9.33579 0.335786 9 0.75 9Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09418 3.59492C4.80128 3.88781 4.80128 4.36268 5.09418 4.65558C5.38707 4.94847 5.86195 4.94847 6.15484 4.65558L8.03855 2.77187V11.6467C8.03855 12.174 8.46597 12.6014 8.99321 12.6014C9.52046 12.6014 9.94788 12.174 9.94788 11.6467V2.75878L11.8447 4.65558C12.1376 4.94847 12.6124 4.94847 12.9053 4.65558C13.1982 4.36268 13.1982 3.88781 12.9053 3.59492L9.53008 0.21967C9.23719 -0.0732232 8.76232 -0.0732232 8.46942 0.21967L5.09418 3.59492Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSmall);
export default __webpack_public_path__ + "static/media/upload_small.a645abc62acd4d5cb111063e9afa0a28.svg";
export { ForwardRef as ReactComponent };